import api from '@/api'

const namespaced = true

const state = {
  staList: [],
  shippers: [],
  fetchColumns: [],
  years: [],
  staDetail: {},
  staFiles: {}
}

const getters = {
  staList: state => state.staList,
  staDetail: state => state.staDetail,
  shippers: state => state.shippers,
  staFiles: state => state.staFiles,
  fetchColumns: state => state.fetchColumns,
  years: state => state.years
}

const mutations = {
  SET_STA_LIST: (state, payload) => {
    state.staList = payload
  },
  SET_SHIPPERS: (state, payload) => {
    state.shippers = payload
  },
  SET_COLUMNS: (state, payload) => {
    state.fetchColumns = payload.sort((a, b) => a.id - b.id)
  },
  SET_YEARS: (state, payload) => {
    state.years = payload
  },
  SET_STA_DETAIL: (state, payload) => {
    state.staDetail = payload
  },
  SET_STA_FILES: (state, payload) => {
    state.staFiles = payload
  }
}

const actions = {
  async fetchSTAList({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage || 1,
        limit: filterConfig.pageSize || 10,
        ...payload
      }
      const { data } = await api.getSTA(filter)
      if (data.error) {
        commit('SET_STA_LIST', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }
      if (!data.data) {
        commit('SET_STA_DETAIL', data)
        return
      }
      commit('SET_STA_LIST', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },

  async fetchShippers({ commit }) {
    try {
      const { data } = await api.getSTAShippers()
      if (data.error) {
        commit('SET_SHIPPERS', [])
        return
      }
      commit('SET_SHIPPERS', data)
    } catch (err) {
      throw err
    }
  },

  async fetchColumns({ commit }) {
    try {
      const { data } = await api.getSTAColumns()
      if (data.error) {
        commit('SET_COLUMNS', [])
        return
      }
      commit('SET_COLUMNS', data)
    } catch (err) {
      throw err
    }
  },

  async fetchYear({ commit }) {
    try {
      const { data } = await api.getSTAYears()
      if (data.error) {
        commit('SET_YEARS', [])
        return
      }
      commit('SET_YEARS', data)
    } catch (err) {
      throw err
    }
  },

  async createSTA({}, payload) {
    try {
      await api.postSTA(payload)
    } catch ({ data }) {
      throw data
    }
  },

  async updateSTA({}, payload) {
    try {
      await api.putSTA(payload.id, payload.form)
    } catch ({ data }) {
      throw data
    }
  },

  async deleteSTA({}, id) {
    try {
      await api.deleteSTA(id)
    } catch (err) {
      throw err
    }
  },
  async downloadSTA({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const response = await api.getSTAExcelDownload({
        search: filterConfig.search,
        ...payload})
      if (response) {
        commit('SET_STA_FILES', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetSTAFiles({ commit }) {
    commit('SET_STA_FILES', {})
  },

  async duplicateSTA({}, payload) {
    try {
      await api.postSTADuplicate(payload)
    } catch ({ data }) {
      throw data
    }
  }
}

export default { namespaced, state, getters, mutations, actions }
